// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__Gs0MW","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__E1-sP"};